module.exports = __webpack_public_path__ + "img/s2_stepimg03@2x.37aaeeaf.png";